import { render } from "./StudyProblemsItemDetail.vue?vue&type=template&id=08b7519e&scoped=true"
import script from "./StudyProblemsItemDetail.vue?vue&type=script&lang=js"
export * from "./StudyProblemsItemDetail.vue?vue&type=script&lang=js"

import "./StudyProblemsItemDetail.vue?vue&type=style&index=0&id=08b7519e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b7519e"]])

export default __exports__